export default class {
    constructor() {
        let newPage = 1;

        document
            .querySelector("#communityEventsLoad")
            ?.addEventListener("click", (e) => {
                // Prevent refresh
                e.preventDefault;
                // Change text value on button
                e.target.innerHTML = "Community events loading...";
                // Call load more
                loadMore(newPage + 1, e);
                // Increase pagination
                newPage++;
            });

        function loadMore(paged, e) {
            jQuery.ajax({
                type: "post",
                url: `${window.location.origin}/wp-admin/admin-ajax.php`,
                dataType: "json",
                data: {
                    action: "load_more_events_community",
                    paged,
                },
                complete: function (response) {
                    if (response.responseText != 0) {
                        jQuery(".community-events .postsInner").append(
                            response.responseText
                        );
                        e.target.innerHTML = "Load more community events";
                    } else {
                        e.target.disabled = true;
                        e.target.innerHTML = "All community events loaded";
                    }
                },
            });
        }
    }
}
